import React, { Component } from 'react';
// import { v4 as uuid } from 'uuid';
// import PropTypes from 'prop-types';

// import { NotificationPropsI, NotificationStylesI } from '../UnityNotification/UnityNotification';

// Placeholders
const addNotification = () => {};
const closeNotification = () => {};
const clearNotifications = () => {};

export default class UnityNotificationsHandler extends Component {
  constructor(props) {
    super(props);
    this._notificationsHandlerRef = React.createRef();
  }

  componentDidMount() {
    this.updateProperties();
  }

  componentDidUpdate() {
    this.updateProperties();
  }

  updateProperties() {
    const { props, _notificationsHandlerRef } = this;
    const unityNotificationsHandler = _notificationsHandlerRef.current;
    const {
      icons,
      colors,
      customTypes,
      allowDuplicates,
      noAnimation,
      onClose,
      target,
      position,
    } = props;
    if (!!unityNotificationsHandler) {
      if (!!icons) unityNotificationsHandler.icons = icons;
      if (!!colors) unityNotificationsHandler.colors = colors;
      if (!!customTypes) unityNotificationsHandler.customTypes = customTypes;
      if (!!allowDuplicates) unityNotificationsHandler.allowDuplicates = allowDuplicates;
      if (!!noAnimation) unityNotificationsHandler.noAnimation = noAnimation;
      if (!!onClose) unityNotificationsHandler.onClose = onClose;
      if (!!target) unityNotificationsHandler.target = target;
      if (!!position) unityNotificationsHandler.position = position;
    }
  }

  render() {
    const {
      _notificationsHandlerRef,
      props: {
        children = [],
        icons = {},
        colors = {},
        customTypes = {},
        allowDuplicates = false,
        noAnimation = false,
        onClose = () => {},
        ...other
      } = {},
    } = this;

    if (!this.props.target) {
      console.warn(`UnityNotificationsHandler was not passed a "target" property.`);
      return <>{children}</>;
    }

    const otherProps = { ...other };
    if (allowDuplicates) otherProps.allowDuplicates = allowDuplicates;
    if (noAnimation) otherProps.noAnimation = noAnimation;

    return (
      <unity-notifications-handler ref={_notificationsHandlerRef} {...otherProps}>
        {children}
      </unity-notifications-handler>
    );
  }
}

export function withNotifications(handlerProps) {
  return function wrapComponent(WrappedComponent) {
    return (props) => {
      const {
        target,
        position,
        icons,
        colors,
        customTypes,
        allowDuplicates,
        noAnimation,
        onClose,
        style = {},
      } = handlerProps || {};
      const _uniqueName = target || "no-name" // uuid();
      const _notificationsHandlerRef = React.createRef();
      const { current: notificationsHandler = null } = _notificationsHandlerRef || {};

      if (!!notificationsHandler) {
        if (!!icons) notificationsHandler.icons = icons;
        if (!!colors) notificationsHandler.colors = colors;
        if (!!customTypes) notificationsHandler.customTypes = customTypes;
        if (!!allowDuplicates) notificationsHandler.allowDuplicates = allowDuplicates;
        if (!!noAnimation) notificationsHandler.noAnimation = noAnimation;
        if (!!onClose) notificationsHandler.onClose = onClose;
      }
      console.log("TARGET ", target)
      return (
        <unity-notifications-handler target={_uniqueName} position={position} ref={_notificationsHandlerRef} style={style}>
          <WrappedComponent
            addNotification={({ target = _uniqueName, notification }) => addNotification({ target, notification })}
            closeNotification={(target = _uniqueName) => closeNotification(target)}
            clearNotifications={(target = _uniqueName) => clearNotifications(target)}
            {...props}
          />
        </unity-notifications-handler>
      );
    };
  };
}

export { addNotification, closeNotification, clearNotifications };

export { default as UnityNotificationsModal } from './UnityNotificationsModal';
export * from './UnityNotificationsModal';

export { default as UnityNotificationsSplitPane } from './UnityNotificationsSplitPane';
export * from './UnityNotificationsSplitPane';